import { Dispatch, SetStateAction, useState } from 'react';

export function TimeSelect({
  options,
  value,
  setValue,
}: {
  options: (string | null)[] | undefined;
  value: string | null;
  setValue: Dispatch<SetStateAction<string | null>>;
}) {
  const [showOptions, setShowOptions] = useState(false);

  return (
    <div css={{ position: 'relative' }}>
      <div css={{ padding: '12px 0' }}>
        <div
          css={{
            height: 34,
            borderBottom: '1px solid #DCDEDA',
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'space-between',
          }}
          onClick={() => setShowOptions((prev) => !prev)}
        >
          {!value?.length ? (
            <span css={{ color: '#BDBFBB' }}>Время</span>
          ) : (
            <span>{value}</span>
          )}

          <svg
            css={{
              width: 20,
              height: 20,
            }}
          >
            <use xlinkHref='#clock-booking' />
          </svg>
        </div>
      </div>
      {showOptions && (
        <div
          css={{
            width: 'calc(100% + 60px)',
            position: 'absolute',
            top: 0,
            marginLeft: -30,
            marginRight: -30,
            padding: '12px 30px 6px',
            background: '#f6f6f5',
            zIndex: 99,
          }}
        >
          <div
            css={{
              height: 34,
              cursor: 'pointer',
              color: '#BDBFBB',
              display: 'flex',
              justifyContent: 'space-between',
            }}
            onClick={() => setShowOptions((prev) => !prev)}
          >
            Время
            <svg
              css={{
                width: 20,
                height: 20,
              }}
            >
              <use xlinkHref='#clock-booking' />
            </svg>
          </div>
          <div
            css={{
              display: 'flex',
              flexDirection: 'column',
              button: {
                width: 'calc(100% + 60px)',
                height: 34,
                textAlign: 'start',
                margin: '0 -30px',
                padding: '0 30px',
                '&:hover': {
                  background: '#e0e0de',
                },
              },
            }}
          >
            {options?.map((option) => (
              <button
                type='button'
                key={option}
                onClick={() => {
                  setValue(option);
                  setShowOptions(false);
                }}
              >
                {option || 'Весь день'}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
